import { motion } from "framer-motion";
import { Drop } from "@phosphor-icons/react";

const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };
const stagger = { visible: { transition: { staggerChildren: 0.08 } } };

const categories = [
  {
    title: "Emulsions",
    products: ["SS 60", "CRS 60", "CRS 65", "CRS 70", "CMS 60"],
  },
  {
    title: "Modified Emulsions",
    products: ["SC-E1", "SC-E2"],
  },
  {
    title: "Primes",
    products: ["Fastset Prime", "MC 30"],
  },
  {
    title: "Fast Coat Pre Coating Fluid",
    products: ["Fast Coat Pre Coating Fluid"],
  },
  {
    title: "Penetration Grade Bitumen",
    products: ["70/100 Bitumen", "50/70 Bitumen", "35/50 Bitumen"],
  },
];

export default function BitumenSolutions() {
  return (
    <div>
      {/* HERO */}
      <section className="relative py-24 lg:py-32 overflow-hidden" data-testid="bitumen-hero">
        <div className="absolute inset-0">
          <img src="/images/bitumen-drums-multiple.jpeg" alt="KZNSC Bitumen Drums" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#0B2D2D]/80" />
        </div>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10">
          <motion.div initial="hidden" animate="visible" variants={stagger}>
            <motion.p variants={fadeUp} className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-[#A7D129] mb-4">Products / Bitumen Solutions</motion.p>
            <motion.h1 variants={fadeUp} className="font-heading font-black text-5xl md:text-7xl tracking-tighter text-white leading-[0.9] mb-6">
              Bitumen &amp;<br />Emulsion Supply
            </motion.h1>
            <motion.p variants={fadeUp} className="text-lg text-[#E0F5F2]/70 max-w-2xl leading-relaxed">
              Comprehensive range of high-grade binders for road construction and maintenance, meeting SANRAL and international quality standards. We supply across the full spectrum of bitumen products for Southern Africa.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* PRODUCTS GRID */}
      <section className="py-20 lg:py-28 bg-white" data-testid="bitumen-products">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10">
          <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-8" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
            {categories.map((cat, i) => (
              <motion.div key={i} variants={fadeUp} className="card-clean rounded-sm p-8" data-testid={`bitumen-category-${i}`}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 bg-[#00A091] flex items-center justify-center flex-shrink-0">
                    <Drop size={20} weight="duotone" className="text-white" />
                  </div>
                  <div>
                    <p className="font-mono text-[10px] text-[#00A091] uppercase tracking-[0.2em] font-bold">Category {i + 1}</p>
                    <h3 className="font-heading font-bold text-lg text-[#0B2D2D]">{cat.title}</h3>
                  </div>
                </div>
                <div className="space-y-2">
                  {cat.products.map((prod, j) => (
                    <div key={j} className="flex items-center gap-3 py-2 border-b border-[#0F4C5C]/10 last:border-0">
                      <div className="w-1.5 h-1.5 bg-[#A7D129] flex-shrink-0" />
                      <span className="text-sm text-[#0B2D2D]/80">{prod}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* STANDARDS BANNER */}
      <section className="bg-[#0F4C5C] py-16" data-testid="standards-banner">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-[#A7D129] mb-4">Quality Assurance</p>
            <h2 className="font-heading font-bold text-2xl md:text-4xl tracking-tight text-white mb-4">
              All Products Meet SANRAL &amp; SABS Standards
            </h2>
            <p className="text-[#E0F5F2]/60 text-base max-w-xl mx-auto">
              Our bitumen and emulsion products undergo rigorous quality control to ensure compliance with South African National Roads Agency and international quality benchmarks.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
